import { Label } from "./ui/label";
import { Plus } from "lucide-react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "./ui/select";

export function EntitySelect({
  label,
  value,
  onChange,
  options,
  disabled,
  testid,
  onAdd,
  addTestid,
  placeholder = "Select…",
}) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <Label>{label}</Label>
        {onAdd && !disabled && (
          <button
            type="button"
            onClick={onAdd}
            className="flex items-center gap-1 text-xs font-semibold text-primary hover:underline"
            data-testid={addTestid}
          >
            <Plus className="h-3.5 w-3.5" /> Add new
          </button>
        )}
      </div>
      <Select value={value ?? ""} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className="h-12 bg-white" data-testid={testid}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
